ApiError = require 'app/scripts/network/api-error'
ApiPromise = require 'app/scripts/network/api-promise'
Payloads = require 'app/scripts/network/payloads'
ModelWithPreferences = require 'app/scripts/models/internal/model-with-preferences'
Board  = require 'app/scripts/models/board'
{ logoDomain } = require '@trello/config'
Promise = require 'bluebird'
_ = require 'underscore'
OrgFeatures = require('@trello/product-features').OrganizationFeatures
AttachmentTypes = require 'app/scripts/data/attachment-types'
attachmentTypeFromUrl = require 'app/scripts/lib/util/url/attachment-type-from-url'

class Enterprise extends ModelWithPreferences
  typeName: 'Enterprise'
  nameAttr: 'name'
  urlRoot: '/1/enterprises'

  constructor: ->
    super
    @_initSubEventsOn 'organizationPrefs'
    return

  initialize: ->
    super

    @licensesLoading = true
    @licensesLoadFailed = false
    @pluginsLoading = true
    @pluginWhitelistingLoading = false

  @lazy
    organizationList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      OrganizationList = require 'app/scripts/models/collections/organization-list'
      new OrganizationList()

    memberList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      MemberList = require 'app/scripts/models/collections/member-list'
      new MemberList()

    pendingOrganizationList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      { PendingOrganizationList } = require 'app/scripts/models/collections/PendingOrganizationList'
      new PendingOrganizationList()

    publicBoardList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      PublicBoardList = require 'app/scripts/models/collections/public-board-list'
      new PublicBoardList()

  getOrganizationPref: (name) ->
    @get('organizationPrefs')?[name]

  setOrganizationPref: (name, value, opts, next) ->
    @update "organizationPrefs/#{ name }", value, opts, (err) =>
      unless err
        @_cascadeOrganizationPrefs(name, value)
      if _.isFunction(next)
        next(err)

  # Optimistically update all cached orgs in this enterprise
  _cascadeOrganizationPrefs: (name, value) ->
    @modelCache.all('Organization').filter (cachedOrg) =>
      cachedOrg.get('idEnterprise') == @id
    .forEach (enterpriseOrg) =>
      enterpriseOrg.set { "prefs/#{ name }": value }

  deleteOrganizationPref: (name, next) ->
    @set { "organizationPrefs/#{ name }": undefined }
    @api {
      type: 'delete'
      method: "organizationPrefs/#{ name }"
    }, next

  setIdpValue: (field, value) ->
    ApiPromise
      url: "/1/enterprises/#{ @id }/idp/#{field}"
      type: 'PUT'
      data:
        value: value
    .then =>
      @set { "idp/#{field}": value }
      @trigger 'change:idp'

  loadPageOfMembers: (query) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    ModelLoader.loadMembersOfEnterprise(@get('name'), query)
    .tap ([members]) =>
      @memberList.add(members) if members.length > 0

  loadLicenses: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    return Promise.resolve() if @licensesLoadFailed

    @licensesLoading = true
    @trigger 'loading:licenses'

    ModelLoader.loadEnterprise @id,
      fields: 'licenses'
      organizations: 'none'
    .catch ApiError.Server, (err) ->
      @licensesLoadFailed = true
      if err.message != "Gateway Timeout"
        throw err
    .then =>
      @licensesLoading = false
      @trigger 'change:licenses'

  loadPageOfOrganizations: (query) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    ModelLoader.loadEnterpriseOrganizations(@get('name'), query)
    .tap ([organizations]) =>
      @organizationList.add(organizations, { merge: true }) if organizations.length > 0

  loadMaxMembers: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    ModelLoader.loadEnterprise @id,
      # load prefs to refresh maxMembers
      fields: 'prefs'
      organizations: 'none'

  loadPlugins: (opts = {})->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    if @plugins and !opts.force
      return Promise.resolve()

    @pluginsLoading = true
    ModelLoader.loadEnterprisePlugins(@id)
    .then (plugins) =>
      @plugins = plugins
      @pluginsLoading = false
    .catch (err) =>
      @pluginsLoading = false
      throw err

  allowPlugin: (idPlugin) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    ApiPromise
      url: "/1/enterprises/#{ @id }/allowedPlugins"
      type: 'POST'
      data:
        idPlugin: idPlugin
    .then =>
      ModelLoader.loadEnterprise @id,
        fields: 'idPluginsAllowed'
    .then =>
      ModelLoader.loadEnterprisePlugins(@id).then (plugins) =>
        @plugins = plugins

  disablePlugin: (idPlugin) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    ApiPromise
      url: "/1/enterprises/#{ @id }/allowedPlugins"
      type: 'DELETE'
      data:
        idPlugin: idPlugin
    .then =>
      ModelLoader.loadEnterprise @id,
        fields: 'idPluginsAllowed'
    .then =>
      ModelLoader.loadEnterprisePlugins(@id).then (plugins) =>
        @plugins = plugins

  loadPageOfPendingOrganizations: (query) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    ModelLoader.loadEnterprisePendingOrganizations(@get('name'), query)
    .tap ([pendingOrganizations]) =>
      @pendingOrganizationList.add(pendingOrganizations) if pendingOrganizations.length > 0

  loadPageOfPublicBoards: (query) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    ModelLoader.loadEnterprisePublicBoards(@get('name'), query)
    .tap ([publicBoards]) =>
      @publicBoardList.add(publicBoards) if publicBoards.length > 0

  # This is silly, but the enterprises endpoint serves more than actual
  # enterprises. There there's also other "collections of teams" that we use to
  # configure sso and for recurring billing. This is how we tell if something
  # from that endpoint is actually an enterprise:
  isRealEnterprise: ->
    OrgFeatures.isFeatureEnabled('enterpriseUI', @getProduct())

  isEnterpriseProductWithoutSSO: ->
    @getProduct() in [113, 114]

  atlassianOrgLinkingEnabled: ->
    return !!@get('prefs')?.atlassianOrganizationLinking

  declinePendingOrganization: (pendingOrganization) ->
    # This is the same as org.cancelEnterpriseJoinRequest, but we can't invoke
    # that from here because the enterprise admin might not have permission to
    # access the org and therefore we might not have the org as a backbone
    # model.
    ApiPromise
      url: "/1/organizations/#{ pendingOrganization.id }/enterpriseJoinRequest"
      type: 'DELETE'
    .then =>
      @pendingOrganizationList.remove(pendingOrganization)

  acceptPendingOrganization: (pendingOrganization) ->
    ApiPromise
      url: "/1/enterprises/#{ @id }/organizations"
      type: 'PUT'
      data:
        idOrganization: pendingOrganization.id
    .then (response) =>
      @pendingOrganizationList.remove(pendingOrganization)

      teamAttrs = if _.isArray(response)
          _.find response, (team) ->
            team.id == pendingOrganization.id
        else
          response

      team = @modelCache.get('Organization', pendingOrganization.id)
      if !team?
        # Dependency required at call site to avoid import cycles, do not lift to top of module
        Organization = require 'app/scripts/models/organization'
        team = new Organization(teamAttrs, modelCache: @modelCache)
      else
        team.set(teamAttrs)

      @organizationList.add(team)
      @trigger 'accept:pendingOrganization', pendingOrganization

  updatePublicBoardsVisibility: (boards, permissionLevel) ->
    idBoards = _.pluck(boards, 'id')

    ApiPromise
      url: "/1/enterprises/#{ @id }/boards/prefs/permissionLevel"
      type: 'PUT'
      data:
        idBoards: idBoards
        value: permissionLevel
        filter: 'public'
    .then (response) =>
      @publicBoardList.remove(boards)

      # If the user tries to access the board view after
      # updating the visibility in the enterprise dashboard,
      # it will not have the new visibility so we have to
      # update the modelCache if it exists
      for idBoard in idBoards
        board = @modelCache.get('Board', idBoard)
        if board?
          updateBoardPrefs = _.extend(board.get('prefs'), permissionLevel: permissionLevel)
          boardNewPrefs = board.get('prefs')
          board.set(updateBoardPrefs)

      @trigger 'change:enterprisePublicBoards'

  getAvailableLicenses: ->
    if @get('licenses')?
      if @get('licenses')?.maxMembers
        @get('licenses').maxMembers - @get('licenses').totalMembers
      else
        Infinity

  getAttachmentRestrictions: ->
    attachmentRestrictions = @get('organizationPrefs')?.attachmentRestrictions

    if attachmentRestrictions?
      {
        enabled: attachmentRestrictions,
        disabled: _.difference(AttachmentTypes, attachmentRestrictions)
      }
    else
      { enabled: AttachmentTypes, disabled: [] }

  getRestrictedAttachmentTypes: ->
    @getAttachmentRestrictions().disabled

  attachmentTypeRestricted: (attachmentType) ->
    attachmentType in @getRestrictedAttachmentTypes()

  attachmentUrlRestricted: (url) ->
    attachmentType = attachmentTypeFromUrl(url)
    @attachmentTypeRestricted(attachmentType)

  getHeaderLogo: ->
    if @get('logoHash')?
      "#{logoDomain}/#{@get('logoHash')}/60.png"
    else
      null

  grantMemberLicense: (member) ->
    ApiPromise
      url: "/1/enterprises/#{ @id }/members/#{ member.id }/licensed"
      type: 'PUT'
      data:
        fields: Payloads.enterpriseMemberFields
        value: true
    .tap (data) =>
      @modelCache.enqueueDelta member, data
      @trigger 'change:memberLicensed'

  setMemberActive: (member, active) ->
    ApiPromise
      url: "/1/enterprises/#{ @id }/members/#{ member.id }/deactivated"
      # Larger enterprises were experiencing deactivation request times that exceeded
      # the default 32 second timeout, so it's increased here to the maximum allowed by
      # server for PUT requests, 2 minutes
      timeout: 120000
      type: 'PUT'
      data:
        fields: Payloads.enterpriseMemberFields
        value: !active
    .tap (data) =>
      @modelCache.enqueueDelta member, data
      @trigger 'change:memberActive'

  removeMember: (member) ->
    ApiPromise
      url: "/1/enterprises/#{ @id }/members/#{member.id}"
      type: 'DELETE'

  assignMemberAdmin: (member) ->
    memberModel = @memberList.get(member.id)
    roles = memberModel.get('roles')
    isMemberAlreadyAdmin = roles.find((role) -> role == 'enterprise.admin')
    if !isMemberAlreadyAdmin
      newRoles = _.clone(roles)
      newRoles.push('enterprise.admin')
      memberModel.set 'roles', newRoles

  revokeMemberAdmin: (member) ->
    memberModel = @memberList.get(member.id)
    roles = memberModel.get('roles')
    isMemberAlreadyAdmin = roles.find((role) -> role == 'enterprise.admin')
    if isMemberAlreadyAdmin
      newRoles = _.clone(roles)
        .filter((role) -> role != 'enterprise.admin')
      memberModel.set 'roles', newRoles

  getTotalMembers: ->
    @get('licenses')?.totalMembers

  isNearMaxMembers: ->
    max = @getMaxMembers()
    return false if !max?
    count = @getTotalMembers()
    # “near” means < 5% capacity remaining, or 20 seats, whichever is less
    max - count <= Math.min(Math.ceil(max * 0.05), 20)

  isAtMaxMembers: ->
    max = @getMaxMembers()
    max? && max <= @getTotalMembers()

  getMaxMembers: ->
    if @get('licenses')
      @get('licenses').maxMembers
    else
      @get('prefs')?.maxMembers

  getMemberCounts: ->
    memberCounts = @get('licenses')?.relatedEnterprises

  hasRelatedEnterprises: ->
    @get('licenses')?.relatedEnterprises.length > 1

  parentEnterprise: ->
    @get('licenses')?.parent

  isPluginAllowed: (idPlugin) ->
    if @get('pluginWhitelistingEnabled')
      idPlugin in (@get('idPluginsAllowed') || [])
    else
      true

  isPluginWhitelistingEnabled: ->
    @get('pluginWhitelistingEnabled')

  getPluginUsageGroups: ->
    result = {
      inUse: [],
      notInUse: [],
      allowed: []
    }

    if !@plugins
      return result

    return @plugins.reduce((acc, plugin) =>
      if plugin.attributes.boardsCount > 0
        acc.inUse.push(plugin)
      else
        acc.notInUse.push(plugin)

      if plugin.id in @get('idPluginsAllowed')
        acc.allowed.push(plugin)

      return acc
    , result)

  getInUsePlugins: ->
    return @getPluginUsageGroups().inUse

  getAllowedPlugins: ->
    return @getPluginUsageGroups().allowed

  getNotInUsePlugins: ->
    return @getPluginUsageGroups().notInUse

  # Plugins that would be disabled if PUPs whitelisting were to be turned on.
  getWouldBeDisabledPlugins: ->
    _.uniq(
      _.difference @getNotInUsePlugins(), @getAllowedPlugins()
    )

  # Plugins that would remain allowed if PUPs whitelisting were to be turned on.
  getWouldRemainAllowedPlugins: ->
    _.uniq(
      _.union @getInUsePlugins(), @getAllowedPlugins()
    )

  setPluginWhitelisting: (enabled) ->
    @pluginWhitelistingLoading = true
    @trigger 'loading:pluginWhitelistingEnabled'
    ApiPromise
      url: "/1/enterprises/#{ @id }/pluginWhitelistingEnabled"
      type: 'PUT'
      data:
        value: enabled
    .then =>
      @set { "pluginWhitelistingEnabled": enabled }
      @pluginWhitelistingLoading = false
      @trigger 'change:pluginWhitelistingEnabled'
    .catch (err) =>
      @pluginWhitelistingLoading = false
      @trigger 'change:pluginWhitelistingEnabled'
      throw err

  enablePluginWhitelisting: =>
    @setPluginWhitelisting(true)

  disablePluginWhitelisting: =>
    @setPluginWhitelisting(false)

  canViewEnterpriseVisibleBoard: (member) ->
    idEnterprise = @get('id')
    return member.organizationList.any((org) -> org.get('idEnterprise') == idEnterprise)

  isAdmin: (member) ->
    member? && member.id in (@get('idAdmins') || [])

  getPaidAccount: ->
    ApiPromise
      url: "/1/enterprises/#{ @id }/paidAccount"
      type: 'GET'

  getAuditLog: ->
    ApiPromise
      url: "/1/enterprises/#{ @id }/auditlog"
      type: 'GET'

  # This is due to do the great Map debacle of 2019. Historically, we stored
  # product information in an object, which can only key by string. It
  # was refactored to use a Map instead, which can have keys of any type. We
  # only ever have one product in an array, so e.g. [111].toString() === 111.
  # However, with a map, it becomes map.get([111]), which does not exist. Thus,
  # we retrieve the first element in the array and use that as the key, since
  # that is what the map will have. I hate JavaScript.
  getProduct: ->
    @get('products')?[0]

module.exports = Enterprise
